import { HeadlessForm } from '@universal-ember/form';

<template>
  <HeadlessForm as |form|>
    <form.Field @name="country" as |field|>
      <div class="my-2 flex flex-col">
        <field.Label>Country</field.Label>
        <field.Select class="border rounded px-2" as |select|>
          <select.Option @value="">Please select...</select.Option>
          <select.Option @value="USA">United States</select.Option>
          <select.Option @value="CA">Canada</select.Option>
          <select.Option @value="GER">Germany</select.Option>
        </field.Select>
      </div>
    </form.Field>

    <button type="submit">Submit</button>
  </HeadlessForm>
</template>